import React from "react";
import { genURL, gengetURLTEST } from './../_getjson';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import axios from "axios";
import isArrayInArray2D from '../CustomFunction/Arraymanage/isArrayInArray2D'
// require('./PopUpOrher.css');
export default class PopUpCsexpense extends React.Component {
    constructor(props) {
        super(props);
        this.Search = React.createRef();
        this.CustomerName = React.createRef();
        this.state = {
            type: this.props.type,
            rows: [],
            Htext: "",
            SHtype: 3,
            selected: "0",
            rowStrAll: []
        }
    }
    componentDidMount() {
        var url = "";
        switch (this.props.type) {
            case "T_Expcode":
                url = "CSEXPENSEJOINCSINCOMETYPE/GETALL?Top=100";
                console.log(genURL(url));
                axios.get(genURL(url), { timeout: 5000 }).then((res) => {
                    var dataArray = [];
                    for (let i = 0; i < res.data.length; i++) {
                        dataArray[i] = {
                            code: res.data[i].CODE,
                            text: res.data[i].MYNAMETH,
                            WTAXRATE: res.data[i].WTAXRATE == null ? "" : res.data[i].WTAXRATE,
                            CALCTAX: res.data[i].CALCTAX,
                            CALCWTAX: res.data[i].CALCWTAX,
                        }
                    }
                    this.setState({ rows: dataArray });
                }).catch(error => {
                    console.log(error);
                });
                this.setState({ Htext: "ค้นหารายการ" });
                break;
            default: break;
        }
    }
    onKeyUp = (e) => {
        if (e.key === 'Enter') {
            var txt = e.target.value;
            this.getItemar(txt);
        }
    }
    onClickSearch = () => {
        var txt = this.CustomerName.current.value;
        this.getItemar(txt);
    }
    getItemar = (data1) => {
        let urlmain;
        if (this.state.selected === "0") {
            urlmain = "CSEXPENSEJOINCSINCOMETYPE/GETCODES?Top=100&Codes=";
        } else {
            urlmain = "CSEXPENSEJOINCSINCOMETYPE/GETNAME?Top=100&Name=";
        }
        this.setState({ openBackdrop: true })
        var url = urlmain + data1 + "&user=" + localStorage.getItem("Username")
        console.log(genURL(url));
        axios.get(genURL(url), { timeout: 5000 }).then(async (res) => {
            var dataArray = [];
            for (let i = 0; i < res.data.length; i++) {
                dataArray[i] = await {
                    code: res.data[i].CODE,
                    text: res.data[i].MYNAMETH,
                    WTAXRATE: res.data[i].WTAXRATE == null ? "" : res.data[i].WTAXRATE,
                    CALCTAX: res.data[i].CALCTAX,
                    CALCWTAX: res.data[i].CALCWTAX,
                }
            }
            await this.setState({ rows: dataArray });
        }).catch(error => {
            console.log(error);
        });
    }
    onSelectRow = async (rowdata) => {
        var rowStrAll = this.state.rowStrAll
        let check = true
        for (let i = 0; i < rowStrAll.length; i++) {
            if (rowdata.code === rowStrAll[i].code) {
                check = false
            }
        }
        if (check) {
            await rowStrAll.push(rowdata)
        }

        this.setState({ rowStrAll: await rowStrAll })
        this.props.GetPopUpCsexpense(this.state.rowStrAll);
    }

    onRowSelect = async (row, isSelected, e) => {
        var rowStrAll = this.state.rowStrAll
        if (isSelected) {
            await rowStrAll.push(row)
        } else if (!isSelected) {
            let rowStrremove = [];
            rowStrremove.push(row);
            this.setState({ rowStrAll: await isArrayInArray2D(rowStrAll, rowStrremove, "code") })
        }
    }
    onSelectAll = async (isSelected, rows) => {
        var rowStrAll = this.state.rowStrAll
        if (isSelected) {
            for (let index = 0; index < rows.length; index++) {
                rowStrAll.push(rows[index])
            }
        } else {
            rowStrAll = []
        }
        this.setState({ rowStrAll: rowStrAll })
    }


    render() {
        const indexN = (cell, row, enumObject, index) => {
            return (<div>{index + 1}</div>)
        }
        const selectRow = {
            mode: 'checkbox',
            onSelect: this.onRowSelect,
            onSelectAll: this.onSelectAll
        }
        return (
            <div className='popup'  >
                <div className='popup_inner '>
                    {this.props.Data}
                    <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1"><i className="fas fa-search" > {this.state.Htext} </i></div>
                        <div className="PopUpOtherDivH2"><i className="fas fa-times" onClick={this.props.closePopup}></i></div>
                    </div>

                    <div className="panel-body divTable" align="left" >
                        <div className="DivTable">
                            <div className="form-inline">
                                <div className="form-group mb-2">
                                    <input type='radio' id='Choice-1' name='myRadio' value='0'
                                        checked={this.state.selected === '0'} onChange={(e) => this.setState({ selected: e.target.value })} /><span className="choiceSty">&nbsp;ค้นหาจากรหัส&nbsp;&nbsp;&nbsp;</span>
                                    <input type='radio' id='Choice-2' name='myRadio' value='1'
                                        checked={this.state.selected === '1'} onChange={(e) => this.setState({ selected: e.target.value })} /><span className="choiceSty">&nbsp;ค้นหาจากชื่อ&nbsp;&nbsp;</span>
                                </div>
                            </div>
                        </div>
                        <div className="input-group width-grop">
                            <input type="text" className="form-control" placeholder="กรอกคำค้นหา" onKeyUp={this.onKeyUp} ref={this.CustomerName} />
                            <span className="input-group-addon txt-img icon"><i className="fas fa-search" onClick={this.onClickSearch}></i></span>
                            <span className="input-group-addon txt-img icon"> <i className="fas fa-sync-alt" onClick={() => { this.componentDidMount() }}></i></span>
                        </div>

                        <BootstrapTable
                            data={this.state.rows}
                            options={{
                                onRowClick: this.onSelectRow,
                                noDataText: "ไม่พบข้อมูลที่ค้นหา",
                            }}
                            selectRow={selectRow}
                            height="700"
                        >
                            <TableHeaderColumn dataAlign="center" width="20" dataField="any" dataFormat={indexN} ></TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField='code' width="50" isKey> รหัส </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField='text' width="300"  > ชื่อ/คำอธิบาย </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField='WTAXRATE' width="50" dataAlign="center"  > % หักณที่จ่าย</TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField='CALCWTAX' width="40" dataAlign="center" > W </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField='CALCTAX' width="40" dataAlign="center" > T </TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>
            </div>
        );
    }
}